/** Aligns with Prisma `WorkspaceModule` and API `module` values. */
export enum WorkspaceAccessModule {
  MEMBERS = "MEMBERS",
  FINANCE = "FINANCE",
  BUDGETING = "BUDGETING",
  ACTIVITIES = "ACTIVITIES",
  REPORTS = "REPORTS",
  SETTINGS = "SETTINGS",
  ASSETS = "ASSETS",
  GROUPS = "GROUPS",
  MINISTRIES = "MINISTRIES",
  DEPARTMENTS = "DEPARTMENTS",
  FORMS = "FORMS",
}

/** Aligns with Prisma `ModuleAccessLevel` and API `access` values. */
export enum WorkspaceAccessPermission {
  NONE = "NONE",
  VIEW = "VIEW",
  EDIT = "EDIT",
}

/**
 * Budget-specific access levels (separate from the generic {@link WorkspaceAccessPermission}). Drives
 * the governed budget workflow: EDITOR creates/edits drafts + submits; APPROVER reviews/approves/marks
 * ready; MANAGER does both + lifecycle management. Used for the BUDGETING rows in the
 * role editor for budgeting permission levels.
 */
export enum BudgetAccessLevel {
  NONE = "NONE",
  VIEW = "VIEW",
  EDITOR = "EDITOR",
  APPROVER = "APPROVER",
  MANAGER = "MANAGER",
}

// FinanceAccessLevel removed (IBA-159 / D3): FINANCE is a standard NONE/VIEW/EDIT module. Its authority is the
// base WorkspaceAccessPermission; advanced finance capabilities are CASL actions on roles, not an access level.

/** Aligns with Prisma `ModuleAccessScope` and API `scope` values. */
export enum WorkspaceAccessScope {
  BRANCH = "BRANCH",
  WORKSPACE = "WORKSPACE",
}

export enum UserBranchAccessStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** Mirrors Prisma `WorkspaceUserStatus` and workspace user API payloads. */
export enum WorkspaceUserStatus {
  Pending = "PENDING",
  Active = "ACTIVE",
  Suspended = "SUSPENDED",
}

/** Mirrors Prisma `WorkspaceMembershipRole`. Workspace authority is OWNER; everyone else is USER. */
export enum WorkspaceMembershipRole {
  Owner = "OWNER",
  User = "USER",
}

/** Workspace and branch role keys returned by auth and team APIs. */
export enum WorkspaceRoleKey {
  Owner = "OWNER",
  Admin = "ADMIN",
  User = "USER",
  WorkspaceAdmin = "WORKSPACE_ADMIN",
  WorkspaceManager = "WORKSPACE_MANAGER",
}

/** Mirrors Prisma `RoleScope`. */
export enum RoleScope {
  Workspace = "WORKSPACE",
  Branch = "BRANCH",
}

/** Mirrors Prisma `RoleStatus`. */
export enum RoleStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

/** Canonical workspace role keys used in RBAC (subset of `WorkspaceRoleKey`). */
export enum RoleKey {
  Owner = "OWNER",
  Admin = "ADMIN",
  User = "USER",
}
